import { application } from './application';
import { registerControllers } from '@helpers/registerControllers';

// Load all `controller.js` files inside `components/portal/**/controller.js`
// TODO: Update this to load controllers lazily {eager: false}. Currently will not connect controllers when lazy loaded
const componentControllers = import.meta.glob('../components/portal/**/controller.js', { eager: true });
registerControllers(application, componentControllers);

const globalControllers = import.meta.glob('../components/global/**/controller.js', { eager: true });
registerControllers(application, globalControllers);


// Loads all legacy component controllers that have yet to be converted
const legacyControllers = import.meta.glob('@controllers/portal/**/*_controller.js', { eager: true });
registerControllers(application, legacyControllers, false);
